import type {
  ResultSocketActionType,
  SocketListenConfig,
  SocketResultData,
  SocketShouldMessageBeAcceptedResult
} from '@/components/results/socket/result-socket-models'
import { doesDomainMatch } from '@/components/results/results-service'
import type { SocketResultMessagePayloadResultsManual } from '@/components/results/socket/socket-results-manual/socket-results-manual-models'

export function shouldSocketMessageBeAccepted(
  message: SocketResultData<SocketResultMessagePayloadResultsManual | unknown>,
  socketListenConfig: SocketListenConfig
): SocketShouldMessageBeAcceptedResult {
  const action: ResultSocketActionType = message.action

  const messageFromDomainMatch = doesDomainMatch(
    message.domain,
    socketListenConfig.listenForMessageDomains
  )
  if (!messageFromDomainMatch) {
    return {
      identifier: 'DOMAIN_NO_MATCH',
      should: false,
      reason:
        message.domain +
        ': is not in the list of domains to listen for: ' +
        socketListenConfig.listenForMessageDomains.join(', '),
      level: 1
    }
  }

  if (!message.comp) {
    return {
      identifier: 'NO_COMP',
      should: false,
      reason: 'No competition specified.',
      level: 2
    }
  }

  if (socketListenConfig.listenForCompIds.indexOf(message.comp.id) === -1) {
    return {
      identifier: 'NO_COMP_ID_MATCH',
      should: false,
      reason:
        message.comp.id +
        ': is not in the list of comps to listen for: ' +
        socketListenConfig.listenForCompIds.join(', '),
      level: 3
    }
  }

  if (socketListenConfig.listenForMessageTypes.indexOf(action) === -1) {
    return {
      identifier: 'MESSAGE_TYPE_NO_MATCH',
      should: false,
      reason:
        message.action +
        ': is not in the list of message types to listen for: ' +
        socketListenConfig.listenForMessageTypes.join(', '),
      level: 4
    }
  }

  return {
    identifier: 'OK',
    should: true,
    reason: '',
    level: 100
  }
}
